module.exports = __webpack_public_path__ + "static/img/226dba9d.svg";